import cn from "../../utils/cn";

const Textarea = ({
  className,
  ...props
}: React.ComponentProps<"textarea">) => {
  return <textarea className={cn("question-comment", className)} {...props} />;
};

export default Textarea;
